"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const client_1 = require("../../../client");
const useProjectState_1 = require("../useProjectState");
const OpeningView_1 = __importDefault(require("./opening/OpeningView"));
function FeatureView() {
    const { gotoEditFile } = (0, client_1.useMapmakerAppConfig)();
    const { featureId } = (0, react_router_dom_1.useParams)();
    const file = (0, useProjectState_1.useProjectFile)();
    const feature = file.design.features[featureId];
    switch (feature === null || feature === void 0 ? void 0 : feature.type) {
        case "OPENING":
            return (0, jsx_runtime_1.jsx)(OpeningView_1.default, { openingId: featureId });
        default:
            // Anything that makes it here should be redirected.
            gotoEditFile(file.id);
            return null;
    }
}
exports.default = FeatureView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmVhdHVyZVZpZXcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wcm9qZWN0L2ZlYXR1cmVzL0ZlYXR1cmVWaWV3LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSx1REFBNkM7QUFDN0MsNENBQXVEO0FBQ3ZELHdEQUFvRDtBQUNwRCx3RUFBZ0Q7QUFFaEQsU0FBd0IsV0FBVztJQUNqQyxNQUFNLEVBQUUsWUFBWSxFQUFFLEdBQUcsSUFBQSw2QkFBb0IsR0FBRSxDQUFDO0lBQ2hELE1BQU0sRUFBRSxTQUFTLEVBQUUsR0FBRyxJQUFBLDRCQUFTLEdBQXlCLENBQUM7SUFDekQsTUFBTSxJQUFJLEdBQUcsSUFBQSxnQ0FBYyxHQUFFLENBQUM7SUFDOUIsTUFBTSxPQUFPLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsU0FBUyxDQUFDLENBQUM7SUFFaEQsUUFBUSxPQUFPLGFBQVAsT0FBTyx1QkFBUCxPQUFPLENBQUUsSUFBSSxFQUFFO1FBQ3JCLEtBQUssU0FBUztZQUNaLE9BQU8sdUJBQUMscUJBQVcsSUFBQyxTQUFTLEVBQUUsU0FBUyxHQUFJLENBQUM7UUFDL0M7WUFDRSxvREFBb0Q7WUFDcEQsWUFBWSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztZQUN0QixPQUFPLElBQUksQ0FBQztLQUNmO0FBQ0gsQ0FBQztBQWRELDhCQWNDIn0=